var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "leave-active-class": "duration-200"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.opened,
      expression: "opened"
    }],
    class: 'ios-scroll overflow-scroll h-full z-50 fixed bottom-0 px-4 inset-0 sm:p-0 ' + (!_vm.dynamicHeight ? 'flex justify-center items-center' : '')
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.opened ? _c('div', {
    staticClass: "fixed inset-0 transition-opacity",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-indigo-600 bg-opacity-85"
  })]) : _vm._e()]), _vm._v(" "), _vm.dynamicHeight || _vm.crossedAbsoluteComponent ? _c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_c('div', {
    class: 'bg-white rounded-lg px-4 pt-5 pb-4 ' + _vm.minHeight + ' max-h-9/10 shadow-xl transform transition-all ' + _vm.width + ' sm:p-6' + (_vm.crossedAbsoluteComponent ? ' overflow-visible' : ' ' + _vm.overflow),
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    }
  }, [!_vm.noCloseButton ? _c('div', {
    staticClass: "cursor-pointer block absolute right-5 top-5 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600",
    on: {
      "click": _vm.close
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [!_vm.dynamicHeight && !_vm.crossedAbsoluteComponent ? _c('div', {
    class: 'bg-white rounded-lg sm:m-5 px-4 pt-5 pb-4 ' + _vm.minHeight + ' max-h-9/10 shadow-xl transform transition-all ' + _vm.width + ' sm:p-6 ' + _vm.overflow,
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    }
  }, [!_vm.noCloseButton ? _c('div', {
    staticClass: "cursor-pointer block absolute right-5 top-5 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600",
    on: {
      "click": _vm.close
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }